import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { RenderCheckBoxField } from '@zola/zola-ui';

import ChecklistTaskItemTag from './ChecklistTaskItemTag';

import './ChecklistTaskItem.less';

const ChecklistTaskItem = (props) => {
  const {
    title,
    id,
    checklistTemplateName,
    isComplete,
    selectedTaskId,
    goToTask,
    completeTask,
    addedByName,
    isSponsoredLinkFromZola,
  } = props;
  const isCurrentlySelected = selectedTaskId === id;
  return (
    <div
      className={classNames(
        'checklist-task-item',
        { 'checklist-task-item--active': isCurrentlySelected },
        { 'checklist-task-item--is_complete': isComplete },
      )}
      onClick={() => goToTask(id)}
      data-testId={`weddingChecklist__taskItem__${title}`}
    >
      {checklistTemplateName && (
        <ChecklistTaskItemTag color="periwinkle">{checklistTemplateName}</ChecklistTaskItemTag>
      )}
      {addedByName && (
        <ChecklistTaskItemTag color="orange">Created by {addedByName}</ChecklistTaskItemTag>
      )}
      {isSponsoredLinkFromZola && (
        <ChecklistTaskItemTag color="green">Easy on Zola</ChecklistTaskItemTag>
      )}
      <div className="task-item__checkbox">
        <div onClick={e => e.stopPropagation()}>
          <RenderCheckBoxField
            className="task-item__checkbox-field"
            type="checkbox"
            id={`task-item__${id}`}
            input={{
              checked: isComplete,
              onChange: () => completeTask(id),
            }}
            meta={{}}
          />
        </div>
        <div className="task-item__label">
          <span className="task-item__strike">{title}</span>
        </div>
      </div>
    </div>
  );
};

ChecklistTaskItem.propTypes = {
  title: PropTypes.string,
  checklistTemplateName: PropTypes.string,
  addedByName: PropTypes.string,
  id: PropTypes.number,
  goToTask: PropTypes.func,
  completeTask: PropTypes.func,
  isComplete: PropTypes.bool,
  isSponsoredLinkFromZola: PropTypes.bool,
};

ChecklistTaskItem.defaultProps = {
  title: '',
};

export default ChecklistTaskItem;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistTaskItem/ChecklistTaskItem.jsx